/**
 * SiteGlue Agent base-plan presentation. Display only.
 * Do not invent prices or change Stripe / hire plan ids.
 */

import {
  SITEGLUE_ACTIVATE_CTA,
  SITEGLUE_PRODUCT_NAME,
} from "~/lib/siteglue/customer-terms";
import { SITEGLUE_MARKETING_CHANNELS } from "~/lib/siteglue/communication-channels";

export const SITEGLUE_BASE_PLAN_DISPLAY_NAME = SITEGLUE_PRODUCT_NAME;

export const SITEGLUE_BASE_INCLUDED = [
  "AI Agents",
  "Live Chat",
  "Connection Reporting",
] as const;

export const SITEGLUE_BASE_PLAN_HELPER =
  "Includes AI Agents + Live Chat and connection reporting. Additional channels optional.";

export const SITEGLUE_ACTIVATE_HELPER = SITEGLUE_BASE_PLAN_HELPER;

const BASE_CHANNEL_IDS = new Set(["website_chat"]);

export const SITEGLUE_ADDON_CHANNELS = SITEGLUE_MARKETING_CHANNELS.filter(
  (channel) => !BASE_CHANNEL_IDS.has(channel.id),
);

export const SITEGLUE_BASE_PLAN_SUMMARY = {
  name: SITEGLUE_BASE_PLAN_DISPLAY_NAME,
  includes: SITEGLUE_BASE_INCLUDED,
  helper: SITEGLUE_BASE_PLAN_HELPER,
  activateLabel: SITEGLUE_ACTIVATE_CTA,
  teamHandoffIncluded: true,
} as const;
